/**
 * body braucht ein Attribut data-page mit der page-id.
 */

/**
 * Hier werden alle Objekte fuer die Seiten gespeichert.
 */
export const pages = [];

/**
 * Ermoeglicht das Hinzufuegen von Funktionen fuer bestimmte Seiten bzw. das
 * Holen aller definierten Seiten.
 */
export const page = function (id, func) {

    if (typeof func !== 'function') {
        throw new Error('Invalid function passed for page with id ' + id);
    }

    pages.push({
        id: id,
        run: func
    });

    return this;
};
